// -----------------------------------------------------------------Imports---
import axios, { AxiosError, AxiosResponse } from "axios";

import { getAppApiRoutes, getAppApiUrlBase } from "../../Global";
import ResponseModel from "../../models/ResponseModel";
import { logUnknownError, UNKNOWN_ERROR_MESSAGE } from "../logger/LoggerService";

// ----------------------------------------------------------------Privates---
class LoginService {
  async onLogin(username: string, password: string): Promise<ResponseModel> {
    let responseData: ResponseModel = {
      status: 400,
      data: {},
      error: {
        message: UNKNOWN_ERROR_MESSAGE,
      },
    };

    await axios
      .post(
        getAppApiUrlBase() + getAppApiRoutes.login.user,
        {
          username: username,
          password: password,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        },
      )
      .then((response: AxiosResponse<ResponseModel>): void => {
        responseData = response.data;
      })
      .catch((error: AxiosError<ResponseModel>): void => {
        if (error.response?.status === 401) {
          responseData = {
            status: error.response.status,
            data: error.response.data?.data ?? null,
            error: error.response.data?.error ?? { message: "Unauthorized" },
          };
        } else if (error.response?.data) {
          responseData = error.response.data;
        } else {
          logUnknownError("LoginService.onLogin", error, {
            endpoint: getAppApiRoutes.login.user,
            username,
          });
        }
      });

    return responseData;
  }

  async onRefresh(): Promise<ResponseModel> {
    let responseData: ResponseModel = {
      status: 400,
      data: {},
      error: {
        message: UNKNOWN_ERROR_MESSAGE,
      },
    };
    const token: string | null = localStorage.getItem("micra_token");

    await axios
      .post(
        getAppApiUrlBase() + getAppApiRoutes.login.userTokenRefresh,
        {},
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            ...(token ? { Authorization: token } : {}),
          },
        },
      )
      .then((response: AxiosResponse<ResponseModel>): void => {
        responseData = response.data;
        const loginData: { token?: string } = (response.data.data ?? {}) as { token?: string };
        if (loginData.token) {
          localStorage.setItem("micra_token", "Bearer " + loginData.token);
        }
      })
      .catch((error: AxiosError<ResponseModel>): void => {
        if (error.response?.status === 401) {
          responseData = {
            status: error.response.status,
            data: error.response.data?.data ?? null,
            error: error.response.data?.error ?? { message: "Unauthorized" },
          };
        } else if (error.response?.data) {
          responseData = error.response.data;
        } else {
          logUnknownError("LoginService.onRefresh", error, {
            endpoint: getAppApiRoutes.login.userTokenRefresh,
          });
        }
      });

    return responseData;
  }
}

// -----------------------------------------------------------------Exports---
const service: LoginService = new LoginService();
export default service;
